import React, { useContext, useEffect, useRef, useState } from "react";
import Style from "./index.module.css";
import { Link, useParams } from "react-router-dom";
import { LocationContext } from "../../../Contexts/LocationContext";
import { AddContext } from "../../../Contexts/AddContext";

const AddCard = () => {
    const { AddData } = useContext(AddContext);
    const { categoryId } = useParams();
    const { location } = useContext(LocationContext);
    const [showAds, setShowAds] = useState([]);

    // Track how many times map() is called
    const mapRenderCount = useRef(0);

    useEffect(() => {
        // console.log("🔹check 1):", AddData);
    }, [AddData]);

    useEffect(() => {
        if (!Array.isArray(AddData) || AddData.length === 0) return;
    
        // console.log("🔹 AddData before filtering:", AddData);
    
        const filteredAds = AddData.filter((ad) => {
            if (ad?.selectedPage === null) return true;
            if (ad?.selectedPage && ad.selectedPage.length > 0) return false;
    
            const hasMatchingDistrict =
                ad.coverageData &&
                Array.isArray(ad.coverageData) &&
                ad.coverageData.some((coverage) =>
                    Array.isArray(coverage.districts) &&
                    coverage.districts.some(
                        (district) =>
                            typeof district === "string" &&
                            typeof location.district === "string" &&
                            district.toLowerCase().trim() === location.district.toLowerCase().trim()
                    )
                );
    
            return hasMatchingDistrict;
        });
    
        console.log("🔹 Filtered Ads:", filteredAds);
    
        // Fix potential duplication issue
        const uniqueAds = filteredAds.filter(
            (ad, index, self) => index === self.findIndex((t) => t._id === ad._id)
        );
    
        // console.log("🔹 Unique Ads after filtering:", uniqueAds);
    
        setShowAds(uniqueAds);
    }, [AddData]); // ✅ Only update when AddData changes
    
    if (showAds.length === 0) return null;
   
    mapRenderCount.current = 0;

    return (
        <div className={Style.adContainer}>
            {showAds.map((ad, index) => {
                const sizeMapping = {
                    1: 235,
                    2: 490,
                    // 3: 725,
                    // 4: 490,
                };
                const heightValueMapping = {
                    1: 350,
                    2: 350,
                    // 3: 550,
                    // 4: 750,
                }
                mapRenderCount.current += 1; // Increment map render count
                // console.log("Map Render Count:", mapRenderCount.current);

                const widthValue = sizeMapping[ad.advSize] || 235;
                // const heightValue = heightValueMapping[ad.advSize] ||350;
                 
                return (
                    <div
                        key={ad._id || index}
                        className={Style.products}
                        style={{ width: `${widthValue}px`}}
                    >
                        <img src={ad.images[0]?.secure_url} alt="Ad" className={Style.card_image} />
                        <Link to={ad.redirectionUrl} target="_blank">
                            <button className={Style.read_more_button}>VISIT SITE</button>
                        </Link>
                    </div>
                );
            })}
        </div>
    );
};

export default AddCard;
